<template>
  <div>
    <v-dialog v-model="dialogverifikasihp" persistent max-width="600">
      <v-card>
        <v-toolbar elevation="0" dark dense class="primary">
          <v-toolbar-title>Verifikasi NoHP</v-toolbar-title>
          <v-spacer/>
          <v-btn @click="setdialogverifyhp(false)" text icon><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-alert type="warning" class="mt-2" rounded shaped>
            <p class="heading text-center mt-2">Verifikasi menggunakan <strong>Whatsapp</strong>, pastikan nomor anda sudah terhubungan dengan Whatsapp</p>
            <p class="text-center"><strong>Nomor Hp Yang sudah diverifikasi tidak bisa diubah</strong></p>
          </v-alert>
          <div><v-text-field  prepend-icon="mdi-whatsapp" v-model="user.member.memberphone" label="No Hp" ></v-text-field></div>
          <v-row>
            <v-col cols="12" md="9">
              <div><v-text-field  prepend-icon="lock" type="number" v-model="newdata.otp" label="Kode OTP" ></v-text-field></div>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn small @click="dosendotp" v-if="normal" text class="accent mt-6">Kirim Kode</v-btn>
              <v-btn block disabled small v-else text class="mt-6">{{timerotp}}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn elevation="0" text dark @click="setdialogverifyhp(false)" color="red">Nanti Saja</v-btn>
          <v-btn elevation="0" text  @click="simpan" color="primary">Verify</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogVerifikasiHP',
  data: () => ({
    normal: true,
    timerotp: 60,
    newdata: {
      phone: '',
      otp: '',
      sid: ''
    }
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('UserStore', ['dialogverifikasihp']),
    ...mapState('SaldoStore', ['otpkey'])
  },
  methods: {
    ...mapActions('UserStore', ['setdialogverifyhp', 'verifyPhone']),
    ...mapActions('SaldoStore', ['getOtp']),
    simpan () {
      this.newdata.sid = this.otpkey
      this.newdata.phone = this.user.member.memberphone
      this.verifyPhone(this.newdata)
    },
    cleanInterval () {
      clearInterval(this.timeconetx)
    },
    dosendotp () {
      this.normal = false
      this.getOtp()
      if (this.timeconetx !== null) {
        this.timerotp = 60
      }
      this.timeconetx = setInterval(() => {
        if (this.timerotp > 0) {
          this.timerotp = this.timerotp - 1
        } else {
          this.normal = true
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>

</style>
